import type { EditableContent as EditableContentType } from '@/types'

interface EditableContentProps {
  content: EditableContentType | null
  fallback?: React.ReactNode
  className?: string
  wrapperClassName?: string
}

/**
 * Composant pour afficher du contenu HTML éditable via GrapesJS.
 * Le contenu inclut le CSS inline généré par l'éditeur.
 */
export function EditableContent({
  content,
  fallback = null,
  className = '',
  wrapperClassName = '',
}: EditableContentProps) {
  // Si pas de contenu, afficher le fallback
  if (!content || !content.html) {
    return fallback ? <>{fallback}</> : null
  }

  return (
    <div className={wrapperClassName}>
      <div
        className={`editable-content ${className}`}
        dangerouslySetInnerHTML={{ __html: content.html }}
      />
    </div>
  )
}
